import {Button, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import {Add} from "@mui/icons-material";
import {useRef} from "react";
import useAlert from "../../../../../../use/useAlert";

const ERROR_NAME_REQUIRED = "Nom requis";
const ERROR_PRICE_REQUIRED = "Prix requis";
const ERROR_QUANTITY_REQUIRED = "Quantité requise";

export default function ({name, onSubmit}) {
    const alert = useAlert();
    const nameInput = useRef();
    const descriptionInput = useRef();
    const priceInput = useRef();
    const quantityInput = useRef();

    const submit = () => {
        if (nameInput.current.value.length === 0) {
            alert.warning(ERROR_NAME_REQUIRED);
            return;
        }

        if (priceInput.current.value.length === 0) {
            alert.warning(ERROR_PRICE_REQUIRED);
            return;
        }

        if (quantityInput.current.value.length === 0) {
            alert.warning(ERROR_QUANTITY_REQUIRED);
            return;
        }

        onSubmit({
            name: nameInput.current.value,
            description: descriptionInput.current.value,
            price: priceInput.current.value,
            quantity: quantityInput.current.value,
            standardized_item_id: null,
            default_item_id: null
        })
    }

    return (
        <>
            <div>
                <TextField
                    inputRef={nameInput}
                    fullWidth
                    variant={"standard"}
                    label={"Nom de l'item"}
                    defaultValue={name}
                    required
                />
            </div>
            <Box mt={2}>
                <TextField
                    inputRef={descriptionInput}
                    fullWidth
                    multiline
                    rows={4}
                    variant={"standard"}
                    label={"Description"}
                    data-test="input-description"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={priceInput}
                    fullWidth
                    autoFocus
                    variant={"standard"}
                    label={"Prix HT"}
                    type={"number"}
                    required
                    data-test="input-price"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={quantityInput}
                    fullWidth
                    variant={"standard"}
                    label={"Quantité"}
                    type={"number"}
                    defaultValue={1}
                    required
                    data-test="input-quantity"
                />
            </Box>
            <Box mt={2} display="flex" justifyContent="center">
                <Button
                    startIcon={<Add/>}
                    variant={"contained"}
                    fullWidth
                    onClick={submit}
                    data-test="button-create-custom"
                >
                    Créer
                </Button>
            </Box>
        </>
    )
}